module.exports = __webpack_public_path__ + "static/media/to_right_white.ca129960.svg";